import { Icon } from "@/components/BaseComponents/Icon";

export const NativeSelectDropdownIcon = (props) => (
	<Icon fill="currentColor" {...props}>
		<path d="M7 10l5 5 5-5z"></path>
	</Icon>
);
